import { generatePath } from 'react-router-dom'
import { SCHEDULED_POSTS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Calendar2, ScheduledFilled } from 'blaze-ui/icons'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Calendar1 } from 'blaze-ui/icons/24'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuScheduledPostsItem = ({ workspaceId, onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <NavMenuItem
      icon={isSystemRedesignEnabled ? Calendar1 : Calendar2}
      activeIcon={isSystemRedesignEnabled ? Calendar1 : ScheduledFilled}
      to={generatePath(SCHEDULED_POSTS_PATH, { workspaceId })}
      onPress={onPress}
      label={'Calendar'}
    />
  )
}

export { NavMenuScheduledPostsItem }
